import {makeDefaultEmpty} from '../../components/DefaultEmpty';

export const qlComponentsMap = {
    QlActionPanelExtension: makeDefaultEmpty<{}>(),
    QlUnconfiguredChartView: makeDefaultEmpty<{}>(),
} as const;
